import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import api from '../lib/api';
import { useCart } from '../context/CartContext';

const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get('session_id');
      if (!sessionId) {
        navigate('/cart');
        return;
      }

      try {
        const response = await api.get(`/checkout/verify?session_id=${sessionId}`);
        setOrderDetails(response.data);
        clearCart();
      } catch (error) {
        console.error('Verification error:', error);
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();
  }, [searchParams, navigate, clearCart]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-12 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <CheckCircle className="w-20 h-20 text-green-600 mx-auto mb-6" />
        <h1 className="font-serif text-4xl mb-4">Thank You for Your Order!</h1>
        <p className="text-gray-600 mb-8">
          Your order has been successfully placed and confirmed.
        </p>

        {orderDetails && (
          <div className="bg-gray-50 p-6 rounded-lg mb-8 text-left">
            <h2 className="font-serif text-2xl mb-4">Order Details</h2>
            <div className="space-y-2">
              <p><strong>Order Number:</strong> {orderDetails.order_number}</p>
              <p><strong>Email:</strong> {orderDetails.email}</p>
              <p className="text-sm text-gray-600 mt-4">
                We've sent a confirmation email with your order details.
              </p>
            </div>
          </div>
        )}

        <div className="flex gap-4 justify-center">
          <Button
            onClick={() => navigate('/account/orders')}
            className="bg-black text-white hover:bg-gray-900"
          >
            View Orders
          </Button>
          <Button
            onClick={() => navigate('/shop')}
            variant="outline"
            className="border-black hover:bg-gray-100"
          >
            Continue Shopping
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;
